import CategoryLinks, { CategoryLinksProps } from './CategoryLinks';

export default CategoryLinks;
export type { CategoryLinksProps };
